// extracted by mini-css-extract-plugin
export default {"wrapperStep":"step-label_wrapperStep__pGV4x","text":"step-label_text__8GXgx"};